var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none",
  viewBox: "0 0 24 25"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 24,
  height: 25,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 .5h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m12 16.5-5-5 1.4-1.45 2.6 2.6V4.5h2v8.15l2.6-2.6L17 11.5zm-6 4q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 18.5v-3h2v3h12v-3h2v3q0 .824-.587 1.413A1.93 1.93 0 0 1 18 20.5z"
}))));
export { SvgDownload as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImRvd25sb2FkIj4KPG1hc2sgaWQ9Im1hc2swXzI3ODlfOTM2MyIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI1Ij4KPHJlY3QgaWQ9IkJvdW5kaW5nIGJveCIgeT0iMC41IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiNGRkZGRkYiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzI3ODlfOTM2MykiPgo8cGF0aCBpZD0iZG93bmxvYWRfMiIgZD0iTTEyIDE2LjVMNyAxMS41TDguNCAxMC4wNUwxMSAxMi42NVY0LjVIMTNWMTIuNjVMMTUuNiAxMC4wNUwxNyAxMS41TDEyIDE2LjVaTTYgMjAuNUM1LjQ1IDIwLjUgNC45NzkxNyAyMC4zMDQyIDQuNTg3NSAxOS45MTI1QzQuMTk1ODMgMTkuNTIwOCA0IDE5LjA1IDQgMTguNVYxNS41SDZWMTguNUgxOFYxNS41SDIwVjE4LjVDMjAgMTkuMDUgMTkuODA0MiAxOS41MjA4IDE5LjQxMjUgMTkuOTEyNUMxOS4wMjA4IDIwLjMwNDIgMTguNTUgMjAuNSAxOCAyMC41SDZaIiBmaWxsPSIjRkZGRkZGIi8+CjwvZz4KPC9nPgo8L3N2Zz4K";